import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { T, PageHeader, Alert } from '../components/UI';

const fmt = (d) => (d ? new Date(d).toLocaleDateString('en-AU', { day:'2-digit', month:'short', year:'numeric' }) : '—');

export const StatusPill = ({ status, failed }) => {
  const s = status === 'draft' ? { label:'Draft', color:'var(--muted)', bg:'var(--bg)' }
    : status === 'sending' ? { label:'Sending…', color:'var(--amber)', bg:'var(--amber-bg)' }
    : failed ? { label:'Sent — some failed', color:'var(--red)', bg:'var(--red-bg)' }
    : { label:'Sent', color:'var(--green)', bg:'var(--green-bg)' };
  return <span style={{ display:'inline-block', padding:'3px 10px', borderRadius:'999px', fontSize:'11px', fontWeight:'600', color:s.color, background:s.bg, border:`1px solid ${s.color}33`, whiteSpace:'nowrap' }}>{s.label}</span>;
};

// Announcements → everything that's been sent (or drafted) to staff
export default function AnnouncementList() {
  const navigate = useNavigate();
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    api.get('/announcements')
      .then(({ data }) => setRows(data.announcements || []))
      .catch(err => setError(err.response?.data?.message || 'Failed to load announcements'))
      .finally(() => setLoading(false));
  }, []);

  const th = { padding:'10px 12px', textAlign:'left', fontSize:'11px', fontWeight:'500', textTransform:'uppercase', letterSpacing:'.5px', color:'var(--muted)', borderBottom:'1px solid var(--border)', whiteSpace:'nowrap' };
  const td = { padding:'11px 12px', fontSize:'13px', color:'var(--text)', verticalAlign:'middle' };
  const mono = { fontFamily:'JetBrains Mono,monospace', fontSize:'12px' };

  return (
    <div style={T.page}>
      <PageHeader title="Announcements" actions={
        <button onClick={()=>navigate('/announcements/new')} style={T.btnPrimary}><i className="ti ti-plus" aria-hidden="true"/> New Announcement</button>
      }/>
      <div style={{ maxWidth:'1000px', margin:'0 auto', padding:'16px 16px 80px' }}>
        {error && <Alert type="error">{error}</Alert>}
        <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:'var(--radius-lg)', overflow:'hidden' }}>
          {loading ? (
            <div style={{ padding:'40px', textAlign:'center' }}><i className="ti ti-loader" style={{ fontSize:'24px', color:'var(--blue)' }} aria-hidden="true"/></div>
          ) : rows.length === 0 ? (
            <div style={{ padding:'48px', textAlign:'center' }}>
              <i className="ti ti-speakerphone" style={{ fontSize:'32px', color:'var(--hint)', display:'block', marginBottom:'12px' }} aria-hidden="true"/>
              <div style={{ fontSize:'14px', fontWeight:'500', color:'var(--text)', marginBottom:'6px' }}>No announcements yet</div>
              <div style={{ fontSize:'12px', color:'var(--muted)', marginBottom:'16px' }}>Email all your staff at once, and share files and videos with them.</div>
              <button onClick={()=>navigate('/announcements/new')} style={T.btnPrimary}>New Announcement</button>
            </div>
          ) : (
            <div className="table-scroll">
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead><tr>{['Title','Sent','Opened','Files / Videos','Status'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
                <tbody>
                  {rows.map(r => (
                    <tr key={r._id} onClick={()=>navigate(`/announcements/${r._id}`)} style={{ cursor:'pointer' }}
                      onMouseEnter={ev=>ev.currentTarget.style.background='var(--bg)'} onMouseLeave={ev=>ev.currentTarget.style.background='transparent'}>
                      <td style={{ ...td, fontWeight:'500' }}>{r.title}<div style={{ fontSize:'11px', color:'var(--muted)', fontWeight:'400' }}>by {r.createdByName}</div></td>
                      <td style={td}><span style={mono}>{fmt(r.sentAt || r.createdAt)}</span></td>
                      <td style={td}><span style={mono}>{r.total ? `${r.opened} / ${r.total}` : '—'}</span></td>
                      <td style={td}><span style={mono}>{r.fileCount} / {r.videoCount}</span></td>
                      <td style={td}><StatusPill status={r.status} failed={r.failed > 0}/></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
